"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmTypeName = exports.CrmType = exports.TestDriveDeliveryMethod = exports.DeliveryMethod = exports.OfferCategoryType = exports.DEFAULT_PURCHASE_TERM = exports.DEFAULT_APR = exports.DEFAULT_TAX = exports.DEFAULT_DOWN_PAYMENT = exports.ReferenceType = exports.ApplicationType = exports.FileFormat = exports.HasCoapplicant = exports.IncidentType = exports.LicenseStatus = exports.Education = exports.ResidenceType = exports.MaritalStatus = exports.Gender = exports.VehicleUse = exports.CoapplicantRelation = exports.RentTypeDropdown = exports.RentType = exports.PRICE_OVERRIDE_FORWARDED_DEFAULT_EXPIRY = exports.PRICE_OVERRIDE_THRESHOLD = exports.PriceOverrideSource = exports.Origin = exports.ColorList = exports.CarStatus = exports.CRMEvent = exports.HigherGearSourceType = exports.VinSolutionsSourceType = exports.ReynoldsSourceType = exports.DealerSocketSourceType = exports.SourceType = exports.MileageType = exports.NotifyFormat = exports.LeaseTermNames = exports.LeaseMileageNames = exports.PurchaseTermNames = exports.CreditRatingMin = exports.CreditRatingMax = exports.DefaultFinanceTerms = exports.FinanceTypeLabels = exports.ExtendedFinanceType = exports.FinanceType = exports.TaxType = exports.EmploymentStatus = exports.Condition = exports.Constants = void 0;
exports.PriceRuleOffsetType = exports.SpecialFees = exports.FixedValueFee = exports.FeeCategory = exports.CurrencyType = exports.HOUR_FORMATS = exports.FuelEfficiencyUnit = exports.DateFormat = exports.Language = exports.CLIENT_TYPE_HEADER = exports.ONLINE_CLIENT_TYPE = exports.CLIENT_TYPE = exports.ActionType = exports.OnlineMinutes = exports.StoreMinutes = exports.StoreStep = exports.WebStepNames = exports.WebStepPath = exports.WebPagePath = exports.WebStep = exports.WebPage = exports.OnlineStepNames = exports.OnlineStepPath = exports.OnlineStep = exports.PriceVariableType = exports.Permissions = exports.UserTypeReadableName = exports.UserType = exports.UserRoleReadableName = exports.UserRole = exports.STATES_CA = exports.STATES = exports.COUNTRIES = exports.CreditRating = exports.InventoryType = exports.TradeInSource = exports.TradeInType = exports.LeadStatus = exports.DealResult = exports.TabletForms = exports.PrintingType = exports.PointsBreakdown = exports.DealAudit = exports.RequestStatus = exports.PencilType = exports.PencilStatus = exports.OtherIncomeSources = exports.FniTypeName = exports.FNIType = exports.SaveLoginType = void 0;
exports.UPSTART_MAX_FINANCE_AMOUNT = exports.UPSTART_MIN_FINANCE_AMOUNT = exports.DisplayFormat = exports.ThirdPartyAccessoryProvider = exports.PreferredContactMethod = exports.ProtectionPlansSelectionType = exports.ORDERED_LENDERS = exports.LENDER_KEY_TO_ID = exports.LENDER_KEY_TO_LABEL = exports.defaultLendersIDs = exports.LENDERS = exports.LenderNames = exports.FAUX_TRADE_IN_ID = exports.NO_SELECTED_MAKES = exports.DealerType = exports.BlackbookValuationType = exports.NotificationChannel = exports.OtherIncomeType = exports.PaycheckFrequency = exports.IncomeSubType = exports.IncomeType = exports.STICKER_FORMAT = exports.COMMUNITY_PROPERTY_STATES = exports.TradeInDataSource = exports.ShiftAnalyticsEventTypes = exports.PixallAnalyticsEventTypes = exports.AppointmentType = exports.LendingFlowType = exports.FormPackType = exports.Signer = exports.FinanceResponseStatus = exports.FinanceApplicationStatus = exports.FinanceProvider = exports.InsuranceRequestType = exports.InsuranceEventType = exports.InsuranceProvider = exports.ImportStatus = exports.Makes = exports.PenProductSource = exports.ChatEventName = exports.ChatStatus = exports.ChatMessageVideoRejectType = exports.ChatMessageType = exports.ChatAuthorType = exports.CarUpgradeType = exports.IncentivesProvider = exports.DealerCashRuleType = exports.PriceRuleSource = void 0;
var Constants;
(function (Constants) {
    Constants["DEMO_DEALER_ID"] = "demo";
    Constants["PRODIGY_DEV_DEALER_ID"] = "demo-dev-routeone";
    Constants["PRODIGY_PROD_DEALER_ID"] = "demo-prod-routeone";
    Constants["EMAIL_TEST_KEYWORD"] = "prodigy";
})(Constants || (exports.Constants = Constants = {}));
var Condition;
(function (Condition) {
    Condition["NEW"] = "New";
    Condition["USED"] = "Used";
    Condition["CPO"] = "CPO";
})(Condition || (exports.Condition = Condition = {}));
// Route One selectors for EmploymentStatus
exports.EmploymentStatus = {
    EMPLOYED: [
        'Active Military',
        'Contract',
        'Full Time',
        'Part Time',
        'Seasonal',
        'Self Employed',
        'Temporary',
    ],
    UNEMPLOYED: ['Retired', 'Not Applicable'],
};
var TaxType;
(function (TaxType) {
    TaxType["STATE"] = "state";
    TaxType["COUNTY"] = "county";
    TaxType["CITY"] = "city";
    // These taxes will apply when a customer lives in the county or city configured
    // Contrast this with the regular COUNTY/CITY, which is dealership location based
    TaxType["CUSTOMER_COUNTY"] = "customerCounty";
})(TaxType || (exports.TaxType = TaxType = {}));
var FinanceType;
(function (FinanceType) {
    FinanceType["PURCHASE"] = "purchase";
    FinanceType["LEASE"] = "lease";
    FinanceType["CASH"] = "cash";
})(FinanceType || (exports.FinanceType = FinanceType = {}));
// For special cases such as OnePayLease
var ExtendedFinanceType;
(function (ExtendedFinanceType) {
    ExtendedFinanceType["ONE_PAY_LEASE"] = "onePayLease";
})(ExtendedFinanceType || (exports.ExtendedFinanceType = ExtendedFinanceType = {}));
// special label for the FinanceCreditForm Ownership Option List
exports.FinanceTypeLabels = Object.assign(Object.assign({}, FinanceType), { PURCHASE: 'finance' });
// Default finance terms that the payment builder allows you to select
exports.DefaultFinanceTerms = {
    PURCHASE: [48, 60, 72],
    LEASE: [36],
};
exports.CreditRatingMax = 850;
exports.CreditRatingMin = 1;
var PurchaseTermNames;
(function (PurchaseTermNames) {
    PurchaseTermNames["TERM1"] = "term1";
    PurchaseTermNames["TERM2"] = "term2";
    PurchaseTermNames["TERM3"] = "term3";
})(PurchaseTermNames || (exports.PurchaseTermNames = PurchaseTermNames = {}));
var LeaseMileageNames;
(function (LeaseMileageNames) {
    LeaseMileageNames["MILEAGE1"] = "mileage1";
    LeaseMileageNames["MILEAGE2"] = "mileage2";
    LeaseMileageNames["MILEAGE3"] = "mileage3";
    LeaseMileageNames["MILEAGE4"] = "mileage4";
    LeaseMileageNames["MILEAGE5"] = "mileage5";
})(LeaseMileageNames || (exports.LeaseMileageNames = LeaseMileageNames = {}));
var LeaseTermNames;
(function (LeaseTermNames) {
    LeaseTermNames["TERM1"] = "term1";
    LeaseTermNames["TERM2"] = "term2";
    LeaseTermNames["TERM3"] = "term3";
    LeaseTermNames["TERM4"] = "term4";
    LeaseTermNames["TERM5"] = "term5";
})(LeaseTermNames || (exports.LeaseTermNames = LeaseTermNames = {}));
var NotifyFormat;
(function (NotifyFormat) {
    NotifyFormat["NEW_LEAD"] = "new-lead";
    NotifyFormat["DRIVER_LICENSE"] = "driver-license";
    NotifyFormat["TURN_OVER"] = "turn-over";
    NotifyFormat["OWNERSHIP_OPTION"] = "ownership-option";
    NotifyFormat["FINANCE_APPLICATION"] = "finance-application";
    NotifyFormat["ONLINE_CONFIRMATION"] = "online-confirmation";
    NotifyFormat["ONLINE_LEAD"] = "online-lead";
    NotifyFormat["ONLINE_SALE"] = "online-sale";
    NotifyFormat["ONLINE_TEST_DRIVE"] = "online-test-drive";
    NotifyFormat["ONLINE_CREDIT_APPLICATION"] = "online-credit-application";
    NotifyFormat["ONLINE_TEST_DRIVE_APPOINTMENT"] = "online-test-drive-appointment";
    NotifyFormat["ONLINE_CREDIT_PULL"] = "online-credit-pull";
    NotifyFormat["DEAL_SUMMARY"] = "deal-summary";
    NotifyFormat["CREDIT_DISCLOSURE"] = "credit-disclosure";
    NotifyFormat["SCANNED_DOCUMENTS"] = "scanned-documents";
    NotifyFormat["OFFER_AGREEMENT"] = "offer-agreement";
    NotifyFormat["PRINT_CREDIT_DISCLOSURE"] = "print-credit-disclosure";
    NotifyFormat["PRINT_CREDIT_APPLICATION"] = "print-credit-application";
    NotifyFormat["PRINT_DRIVER_LICENSE"] = "print-driver-license";
    NotifyFormat["PRINT_SCANNED_DOCUMENTS"] = "print-scanned-documents";
    NotifyFormat["PRINT_PHONEUP_SHEET"] = "print-phoneup-sheet";
    NotifyFormat["NEEDS_ANALYSIS"] = "needs-analysis";
    NotifyFormat["OFFLINE_PRINTER"] = "offline-printer";
    NotifyFormat["TRADE_APPRAISAL"] = "trade-appraisal";
    NotifyFormat["THIRD_PARTY_LEAD"] = "third-party-lead";
    NotifyFormat["THIRD_PARTY_LEAD_NO_VEHICLE"] = "third-party-lead-no-vehicle";
    NotifyFormat["INSURANCE_TEXT"] = "insurance-text";
    NotifyFormat["FINANCING_CONFIRMATION"] = "financing-confirmation";
})(NotifyFormat || (exports.NotifyFormat = NotifyFormat = {}));
exports.MileageType = {
    LOW_MILEAGE: 12000,
    STANDARD_MILEAGE: 15000,
    HIGH_MILEAGE: 18000,
};
var SourceType;
(function (SourceType) {
    SourceType["INTERNET"] = "internet";
    SourceType["PHONE"] = "phone";
    SourceType["SHOWROOM"] = "showroom";
    SourceType["CAMPAIGN"] = "campaign";
})(SourceType || (exports.SourceType = SourceType = {}));
var DealerSocketSourceType;
(function (DealerSocketSourceType) {
    DealerSocketSourceType["Prospect"] = "Prospect";
    DealerSocketSourceType["Customer"] = "Customer";
    DealerSocketSourceType["Employee"] = "Employee";
    DealerSocketSourceType["Vendor"] = "Vendor";
    DealerSocketSourceType["Partner"] = "Partner";
})(DealerSocketSourceType || (exports.DealerSocketSourceType = DealerSocketSourceType = {}));
var ReynoldsSourceType;
(function (ReynoldsSourceType) {
    ReynoldsSourceType["Walk-In"] = "Walk-In";
    ReynoldsSourceType["Fax"] = "Fax";
    ReynoldsSourceType["Internet"] = "Internet";
    ReynoldsSourceType["Phone"] = "Phone";
    ReynoldsSourceType["List"] = "List";
    ReynoldsSourceType["Other"] = "Other";
})(ReynoldsSourceType || (exports.ReynoldsSourceType = ReynoldsSourceType = {}));
exports.VinSolutionsSourceType = {
    1: 'Internet',
    2: 'Walk-In',
    3: 'Phone',
    4: 'Import',
};
exports.HigherGearSourceType = {
    1: 'Store-Up',
    4: 'Phone-Up',
    5: 'BDC-Up',
    3: 'Internet',
    7: 'Fax-Up',
};
var CRMEvent;
(function (CRMEvent) {
    CRMEvent["SHOWROOM"] = "showroom";
    CRMEvent["DEMO"] = "demo";
    CRMEvent["WRITE_UP"] = "write-up";
    CRMEvent["TURN_OVER"] = "turn-over";
    CRMEvent["TRADE_APPRAISAL"] = "trade-appraisal";
    CRMEvent["SOLD"] = "sold";
    CRMEvent["NOOP"] = "noop";
})(CRMEvent || (exports.CRMEvent = CRMEvent = {}));
var CarStatus;
(function (CarStatus) {
    CarStatus["IMPORTED"] = "imported";
    CarStatus["AVAILABLE"] = "available";
    CarStatus["SOLD"] = "sold";
    CarStatus["MANUALLY_ENTERED"] = "manuallyEntered";
    CarStatus["SALE_PENDING"] = "salePending";
    CarStatus["BYO"] = "byo";
})(CarStatus || (exports.CarStatus = CarStatus = {}));
exports.ColorList = [
    'White',
    'Silver',
    'Black',
    'Gray',
    'Blue',
    'Red',
    'Brown',
    'Green',
    'Other',
];
var Origin;
(function (Origin) {
    Origin["INSTORE"] = "In-store";
    Origin["ONLINE"] = "Online";
    Origin["FORWARDED"] = "Forwarded";
    Origin["DESKING"] = "Desking";
    Origin["BYO"] = "BYO";
})(Origin || (exports.Origin = Origin = {}));
var PriceOverrideSource;
(function (PriceOverrideSource) {
    PriceOverrideSource["INSTORE"] = "In-store";
    PriceOverrideSource["ONLINE"] = "Online";
    PriceOverrideSource["FORWARDED"] = "Forwarded";
})(PriceOverrideSource || (exports.PriceOverrideSource = PriceOverrideSource = {}));
// max percent difference for an price override compared to car.price
exports.PRICE_OVERRIDE_THRESHOLD = 0.25;
// default number of days before a forwarded price override gets expired
exports.PRICE_OVERRIDE_FORWARDED_DEFAULT_EXPIRY = 14;
exports.RentType = ['rent', 'own', 'family', 'mortgage', 'other'];
var RentTypeDropdown;
(function (RentTypeDropdown) {
    RentTypeDropdown["rent"] = "Rent";
    RentTypeDropdown["own"] = "Owns Outright";
    RentTypeDropdown["family"] = "Lives with family";
    RentTypeDropdown["mortgage"] = "Mortgage";
    RentTypeDropdown["other"] = "Other";
})(RentTypeDropdown || (exports.RentTypeDropdown = RentTypeDropdown = {}));
exports.CoapplicantRelation = [
    'Resides With',
    'Parent',
    'Spouse',
    'Other',
];
exports.VehicleUse = ['Commute', 'Pleasure', 'Business'];
exports.Gender = ['M', 'F'];
exports.MaritalStatus = [
    'Single',
    'Married',
    'Divorced',
    'Separated',
    'Widowed',
    'Domestic Partner',
];
exports.ResidenceType = [
    'Home',
    'Condo',
    'Townhouse',
    'Mobile Home',
    'Other',
];
exports.Education = [
    'Some High School',
    'High School',
    'Some College',
    '2 Year College',
    '4 Year College',
    'Graduate Degree',
    'Doctorate',
];
exports.LicenseStatus = [
    'Valid',
    'Permit',
    'Expired',
    'Suspended',
    'Cancelled',
    'Not Licensed',
    'Permanently Revoked',
];
exports.IncidentType = [
    'Accident',
    'Claim',
    'DUI',
    'Moving Violation',
    'Other Violation',
    'Speeding',
];
exports.HasCoapplicant = ['yes', 'no'];
var FileFormat;
(function (FileFormat) {
    FileFormat["PDF"] = "pdf";
})(FileFormat || (exports.FileFormat = FileFormat = {}));
var ApplicationType;
(function (ApplicationType) {
    ApplicationType["FIVE_LINE"] = "5 Line";
    ApplicationType["CREDIT_APPLICATION"] = "Credit Application";
    ApplicationType["PHONEUP_SHEET"] = "PhoneUp Sheet";
    ApplicationType["NEEDS_ANALYSIS"] = "Needs Analysis";
    ApplicationType["DRIVER_LICENSE"] = "Driver License";
    ApplicationType["SCANNED_DOCUMENTS"] = "Scanned Documents";
    ApplicationType["TRADE_APPRAISAL"] = "Trade Appraisal";
    ApplicationType["DEAL_SUMMARY"] = "Deal Summary";
})(ApplicationType || (exports.ApplicationType = ApplicationType = {}));
var ReferenceType;
(function (ReferenceType) {
    ReferenceType["FRIEND"] = "Friend (over 1 year)";
    ReferenceType["RELATIVE"] = "Nearest Living Relative";
})(ReferenceType || (exports.ReferenceType = ReferenceType = {}));
exports.DEFAULT_DOWN_PAYMENT = 0.1;
exports.DEFAULT_TAX = 0;
exports.DEFAULT_APR = 0.069;
exports.DEFAULT_PURCHASE_TERM = 72;
var OfferCategoryType;
(function (OfferCategoryType) {
    OfferCategoryType["LOW_INTEREST"] = "lowInterest";
    OfferCategoryType["HIGH_REBATE"] = "highRebate";
})(OfferCategoryType || (exports.OfferCategoryType = OfferCategoryType = {}));
var DeliveryMethod;
(function (DeliveryMethod) {
    DeliveryMethod["PICKUP"] = "pickup";
    DeliveryMethod["DELIVERY"] = "delivery";
})(DeliveryMethod || (exports.DeliveryMethod = DeliveryMethod = {}));
var TestDriveDeliveryMethod;
(function (TestDriveDeliveryMethod) {
    TestDriveDeliveryMethod["INSTORE"] = "in-store";
    TestDriveDeliveryMethod["REMOTE"] = "remote";
})(TestDriveDeliveryMethod || (exports.TestDriveDeliveryMethod = TestDriveDeliveryMethod = {}));
var CrmType;
(function (CrmType) {
    CrmType["ELEAD"] = "elead";
    CrmType["DEALERSOCKET"] = "dealersocket";
    CrmType["REYNOLDS"] = "reynolds";
    CrmType["VINSOLUTIONS"] = "vinsolutions";
    CrmType["HIGHERGEAR"] = "highergear";
    CrmType["STANDALONE"] = "standalone";
    CrmType["DGDG_SALESFORCE"] = "dgdgsalesforce";
})(CrmType || (exports.CrmType = CrmType = {}));
exports.CrmTypeName = {
    [CrmType.DEALERSOCKET]: 'DealerSocket',
    [CrmType.ELEAD]: 'Elead',
    [CrmType.HIGHERGEAR]: 'HigherGear',
    [CrmType.REYNOLDS]: 'Reynolds and Reynolds',
    [CrmType.VINSOLUTIONS]: 'VinSolutions',
    [CrmType.STANDALONE]: 'Other',
    [CrmType.DGDG_SALESFORCE]: 'DGDG Salesforce',
};
var SaveLoginType;
(function (SaveLoginType) {
    SaveLoginType["ELEAD"] = "elead";
    SaveLoginType["DEALERSOCKET"] = "dealersocket";
    SaveLoginType["REYNOLDS"] = "reynolds";
    SaveLoginType["VINSOLUTIONS"] = "vinsolutions";
    SaveLoginType["HIGHERGEAR"] = "highergear";
    SaveLoginType["STANDALONE"] = "standalone";
    SaveLoginType["VAUTO"] = "vauto";
})(SaveLoginType || (exports.SaveLoginType = SaveLoginType = {}));
var FNIType;
(function (FNIType) {
    FNIType["DEALERTRACK"] = "dealertrack";
    FNIType["ROUTEONE"] = "routeone";
    FNIType["CUDL"] = "cudl";
})(FNIType || (exports.FNIType = FNIType = {}));
exports.FniTypeName = {
    [FNIType.CUDL]: 'CUDL',
    [FNIType.DEALERTRACK]: 'Dealertrack',
    [FNIType.ROUTEONE]: 'RouteOne',
};
var OtherIncomeSources;
(function (OtherIncomeSources) {
    OtherIncomeSources["AIDDEPCHILD"] = "Aid for Dependent Children";
    OtherIncomeSources["CHILDSUPPORT"] = "Child Support";
    OtherIncomeSources["COLA"] = "Cost of Living Allowance (COLA)";
    OtherIncomeSources["DISABILITY"] = "Disability";
    OtherIncomeSources["FSSA"] = "Family Subsistence Supplemental Allowance (FSSA)";
    OtherIncomeSources["HOUSINGALLOW"] = "Housing Allowances";
    OtherIncomeSources["MILITARYBAS"] = "Military Basic Allowance for Subsistence (BAS)";
    OtherIncomeSources["MUNBONDINT"] = "Municipal Bond Interest";
    OtherIncomeSources["NONTAXINCOME"] = "Other Non-Taxable Sources of Income";
    OtherIncomeSources["OTHCSTM"] = "Other";
    OtherIncomeSources["PUBLICASST"] = "Public Assistance";
    OtherIncomeSources["RAILPENSION"] = "Railroad Pension";
    OtherIncomeSources["2NDEMPLOYER"] = "Second Employer";
    OtherIncomeSources["SOCSECBEN"] = "Social Security Benefits";
    OtherIncomeSources["WORKMANCOMP"] = "Workman's Compensation";
})(OtherIncomeSources || (exports.OtherIncomeSources = OtherIncomeSources = {}));
var PencilStatus;
(function (PencilStatus) {
    PencilStatus["REQUESTED"] = "requested";
    PencilStatus["SENT"] = "sent";
    PencilStatus["PRESENTED"] = "presented";
    PencilStatus["ACCEPTED"] = "accepted";
    PencilStatus["EXPIRED"] = "expired";
})(PencilStatus || (exports.PencilStatus = PencilStatus = {}));
var PencilType;
(function (PencilType) {
    PencilType["DEFAULT"] = "default";
    PencilType["MANAGER"] = "manager";
})(PencilType || (exports.PencilType = PencilType = {}));
var RequestStatus;
(function (RequestStatus) {
    RequestStatus["REQUESTED"] = "requested";
    RequestStatus["ACCEPTED"] = "accepted";
})(RequestStatus || (exports.RequestStatus = RequestStatus = {}));
var DealAudit;
(function (DealAudit) {
    DealAudit["DRIVER_LICENSE"] = "driverLicense";
    DealAudit["SCANNED_DOCUMENTS"] = "scannedDocuments";
    DealAudit["CREDIT_APPLICATION"] = "creditApplication";
    DealAudit["VEHICLE_SELECTION"] = "vehicleSelection";
    DealAudit["TEST_DRIVE"] = "testDrive";
    DealAudit["FORM_PRINT"] = "formPrint";
    DealAudit["TRADE_IN"] = "tradeIn";
    DealAudit["CREATE_CRM_LEAD"] = "createCrmLead";
})(DealAudit || (exports.DealAudit = DealAudit = {}));
exports.PointsBreakdown = {
    [DealAudit.DRIVER_LICENSE]: 3,
    [DealAudit.SCANNED_DOCUMENTS]: 3,
    [DealAudit.TEST_DRIVE]: 3,
    [DealAudit.TRADE_IN]: 6,
    [DealAudit.CREDIT_APPLICATION]: 4,
    [DealAudit.VEHICLE_SELECTION]: 3,
    [DealAudit.CREATE_CRM_LEAD]: 2,
    [DealAudit.FORM_PRINT]: 5,
};
var PrintingType;
(function (PrintingType) {
    PrintingType["LOCAL"] = "local";
    PrintingType["AIRPRINT"] = "airprint";
    PrintingType["GOOGLE_CLOUD"] = "google-cloud";
})(PrintingType || (exports.PrintingType = PrintingType = {}));
var TabletForms;
(function (TabletForms) {
    TabletForms["DEAL_LOOKUP"] = "dealLookup";
    TabletForms["CUSTOMER_INFO"] = "customerInfo";
    TabletForms["FIVE_LINE"] = "fiveLine";
    TabletForms["FULL_CREDIT_APPLICATION"] = "fullCreditApplication";
    TabletForms["OWNERSHIP_OPTION"] = "ownershipOption";
})(TabletForms || (exports.TabletForms = TabletForms = {}));
var DealResult;
(function (DealResult) {
    DealResult["SOLD"] = "sold";
    DealResult["DID_NOT_PURCHASE"] = "did-not-purchase";
})(DealResult || (exports.DealResult = DealResult = {}));
var LeadStatus;
(function (LeadStatus) {
    LeadStatus["NEW"] = "new";
    LeadStatus["EXISTING"] = "existing";
    LeadStatus["INACTIVE"] = "inactive";
    LeadStatus["SOLD"] = "sold";
})(LeadStatus || (exports.LeadStatus = LeadStatus = {}));
var TradeInType;
(function (TradeInType) {
    TradeInType["VAUTO"] = "vauto";
    TradeInType["FIRSTLOOK"] = "firstlook";
})(TradeInType || (exports.TradeInType = TradeInType = {}));
var TradeInSource;
(function (TradeInSource) {
    TradeInSource["DEFAULT"] = "default";
    TradeInSource["KBB"] = "KBB";
    TradeInSource["ACU_TRADE"] = "acuTrade";
    TradeInSource["SUBARU_GTP"] = "subaruGtp";
    TradeInSource["KBBICO"] = "KBB_ICO";
    TradeInSource["BLACKBOOK"] = "BLACKBOOK";
    TradeInSource["TRADEPENDING"] = "TRADEPENDING";
})(TradeInSource || (exports.TradeInSource = TradeInSource = {}));
var InventoryType;
(function (InventoryType) {
    InventoryType["OTHER"] = "other";
    InventoryType["AUTOJINI"] = "autojini";
    InventoryType["AUTOUPLINKTECH"] = "autouplinktech";
    InventoryType["DEALERCARSEARCH"] = "dealercarsearch";
    InventoryType["DEALERDOTCOM"] = "dealerdotcom";
    InventoryType["DEALERINSPIRE"] = "dealerinspire";
    InventoryType["DEALERSOCKET"] = "dealersocket";
    InventoryType["DEALERTRACK"] = "dealertrack";
    InventoryType["DEALERVISION"] = "dealervision";
    InventoryType["EBIZAUTOS"] = "ebizautos";
    InventoryType["ELEAD"] = "elead";
    InventoryType["FUSIONZONE"] = "fusionzone";
    InventoryType["HOMENETAUTO"] = "homenetauto";
    InventoryType["INVENTORYPLUS"] = "inventoryplus";
    InventoryType["MAXDIGITAL"] = "maxdigital";
    InventoryType["PIX"] = "pix";
    InventoryType["VAUTO"] = "vauto";
})(InventoryType || (exports.InventoryType = InventoryType = {}));
var CreditRating;
(function (CreditRating) {
    CreditRating["POOR"] = "poor";
    CreditRating["AVERAGE"] = "average";
    CreditRating["GOOD"] = "good";
    CreditRating["EXCELLENT"] = "excellent";
})(CreditRating || (exports.CreditRating = CreditRating = {}));
var COUNTRIES;
(function (COUNTRIES) {
    COUNTRIES["US"] = "US";
    COUNTRIES["CA"] = "CA";
})(COUNTRIES || (exports.COUNTRIES = COUNTRIES = {}));
var STATES;
(function (STATES) {
    STATES["AL"] = "Alabama";
    STATES["AK"] = "Alaska";
    STATES["AS"] = "American Samoa";
    STATES["AZ"] = "Arizona";
    STATES["AR"] = "Arkansas";
    STATES["CA"] = "California";
    STATES["CO"] = "Colorado";
    STATES["CT"] = "Connecticut";
    STATES["DE"] = "Delaware";
    STATES["DC"] = "District Of Columbia";
    STATES["FM"] = "Federated States Of Micronesia";
    STATES["FL"] = "Florida";
    STATES["GA"] = "Georgia";
    STATES["GU"] = "Guam";
    STATES["HI"] = "Hawaii";
    STATES["ID"] = "Idaho";
    STATES["IL"] = "Illinois";
    STATES["IN"] = "Indiana";
    STATES["IA"] = "Iowa";
    STATES["KS"] = "Kansas";
    STATES["KY"] = "Kentucky";
    STATES["LA"] = "Louisiana";
    STATES["ME"] = "Maine";
    STATES["MH"] = "Marshall Islands";
    STATES["MD"] = "Maryland";
    STATES["MA"] = "Massachusetts";
    STATES["MI"] = "Michigan";
    STATES["MN"] = "Minnesota";
    STATES["MS"] = "Mississippi";
    STATES["MO"] = "Missouri";
    STATES["MT"] = "Montana";
    STATES["NE"] = "Nebraska";
    STATES["NV"] = "Nevada";
    STATES["NH"] = "New Hampshire";
    STATES["NJ"] = "New Jersey";
    STATES["NM"] = "New Mexico";
    STATES["NY"] = "New York";
    STATES["NC"] = "North Carolina";
    STATES["ND"] = "North Dakota";
    STATES["MP"] = "Northern Mariana Islands";
    STATES["OH"] = "Ohio";
    STATES["OK"] = "Oklahoma";
    STATES["OR"] = "Oregon";
    STATES["PW"] = "Palau";
    STATES["PA"] = "Pennsylvania";
    STATES["PR"] = "Puerto Rico";
    STATES["RI"] = "Rhode Island";
    STATES["SC"] = "South Carolina";
    STATES["SD"] = "South Dakota";
    STATES["TN"] = "Tennessee";
    STATES["TX"] = "Texas";
    STATES["UT"] = "Utah";
    STATES["VT"] = "Vermont";
    STATES["VI"] = "Virgin Islands";
    STATES["VA"] = "Virginia";
    STATES["WA"] = "Washington";
    STATES["WV"] = "West Virginia";
    STATES["WI"] = "Wisconsin";
    STATES["WY"] = "Wyoming";
})(STATES || (exports.STATES = STATES = {}));
var STATES_CA;
(function (STATES_CA) {
    STATES_CA["AB"] = "Alberta";
    STATES_CA["BC"] = "British Columbia";
    STATES_CA["MB"] = "Manitoba";
    STATES_CA["NB"] = "New Brunswick";
    STATES_CA["NL"] = "Newfoundland and Labrador";
    STATES_CA["NS"] = "Nova Scotia";
    STATES_CA["NT"] = "Northwest Territories";
    STATES_CA["NU"] = "Nunavut";
    STATES_CA["ON"] = "Ontario";
    STATES_CA["PE"] = "Prince Edward Island";
    STATES_CA["QC"] = "Quebec";
    STATES_CA["SK"] = "Saskatchewan";
    STATES_CA["YT"] = "Yukon";
})(STATES_CA || (exports.STATES_CA = STATES_CA = {}));
var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "admin";
    UserRole["ACCOUNT_MANAGER"] = "account_manager";
    UserRole["DEALER_ADMIN"] = "dealer_admin";
    UserRole["DEALER_MANAGER"] = "dealer_manager";
    UserRole["DESKING_MANAGER"] = "desking_manager";
    UserRole["DIGITAL_FINANCE_SALES_MANAGER"] = "digital_finance_sales_manager";
    UserRole["DIGITAL_FINANCE_FINANCE_MANAGER"] = "digital_finance_finance_manager";
    UserRole["USER"] = "user";
    UserRole["SELF_DESKING"] = "self_desking";
    UserRole["ONLINE_USER"] = "online_user";
    UserRole["INTEGRATION_USER"] = "integration_user";
})(UserRole || (exports.UserRole = UserRole = {}));
exports.UserRoleReadableName = {
    [UserRole.ADMIN]: 'Admin',
    [UserRole.ACCOUNT_MANAGER]: 'Account manager',
    [UserRole.DEALER_ADMIN]: 'Dealer admin',
    [UserRole.DEALER_MANAGER]: 'Dealer manager',
    [UserRole.DESKING_MANAGER]: 'Desking manager',
    [UserRole.DIGITAL_FINANCE_SALES_MANAGER]: 'Digital finance sales manager',
    [UserRole.DIGITAL_FINANCE_FINANCE_MANAGER]: 'Digital finance finance manager',
    [UserRole.USER]: 'User',
    [UserRole.SELF_DESKING]: 'Self desking',
    [UserRole.ONLINE_USER]: 'Online user',
    [UserRole.INTEGRATION_USER]: 'Integration user',
};
var UserType;
(function (UserType) {
    UserType["CLIENT"] = "client";
    UserType["EMPLOYEE"] = "employee";
    UserType["ADVANCED"] = "advanced";
})(UserType || (exports.UserType = UserType = {}));
exports.UserTypeReadableName = {
    [UserType.CLIENT]: 'Dealer',
    [UserType.ADVANCED]: 'Dealer',
    [UserType.EMPLOYEE]: 'Upstart',
};
var Permissions;
(function (Permissions) {
    Permissions["READ"] = "read";
    Permissions["CREATE"] = "create";
    Permissions["UPDATE"] = "update";
    Permissions["DELETE"] = "delete";
})(Permissions || (exports.Permissions = Permissions = {}));
var PriceVariableType;
(function (PriceVariableType) {
    PriceVariableType["DISCOUNT"] = "discount";
    PriceVariableType["UPGRADE"] = "upgrade";
    PriceVariableType["OTHER"] = "other";
})(PriceVariableType || (exports.PriceVariableType = PriceVariableType = {}));
var OnlineStep;
(function (OnlineStep) {
    OnlineStep["browse"] = "browse";
    OnlineStep["dealStart"] = "dealStart";
    OnlineStep["tradeIn"] = "tradeIn";
    OnlineStep["softCreditPull"] = "softCreditPull";
    OnlineStep["paymentBuilder"] = "paymentBuilder";
    OnlineStep["upgradePackages"] = "upgradePackages";
    OnlineStep["creditApplication"] = "creditApplication";
    OnlineStep["schedulePickup"] = "schedulePickup";
    OnlineStep["testDrive"] = "testDrive";
    OnlineStep["deposit"] = "deposit";
    OnlineStep["vehicleSelection"] = "vehicleSelection";
    OnlineStep["customerInfo"] = "customerInfo";
    OnlineStep["accessories"] = "accessories";
    OnlineStep["insurance"] = "insurance";
    OnlineStep["documentUpload"] = "documentUpload";
    OnlineStep["signDocuments"] = "signDocuments";
})(OnlineStep || (exports.OnlineStep = OnlineStep = {}));
exports.OnlineStepPath = {
    [OnlineStep.browse]: 'browse',
    [OnlineStep.dealStart]: '',
    [OnlineStep.tradeIn]: 'trade-in',
    [OnlineStep.softCreditPull]: 'credit-pull',
    [OnlineStep.paymentBuilder]: 'payment-builder',
    [OnlineStep.upgradePackages]: 'upgrade-packages',
    [OnlineStep.creditApplication]: 'pre-approval',
    [OnlineStep.schedulePickup]: 'Schedule Pickup/Delivery',
    [OnlineStep.testDrive]: 'schedule-test-drive',
    [OnlineStep.deposit]: 'deposit',
    [OnlineStep.vehicleSelection]: 'v',
    [OnlineStep.customerInfo]: 'user-info',
    [OnlineStep.accessories]: 'accessories',
    [OnlineStep.insurance]: 'insurance',
    [OnlineStep.documentUpload]: 'document-upload',
    [OnlineStep.signDocuments]: 'sign-documents',
};
exports.OnlineStepNames = {
    [OnlineStep.browse]: 'Browse',
    [OnlineStep.dealStart]: 'Deal Start',
    [OnlineStep.tradeIn]: 'Trade-in',
    [OnlineStep.softCreditPull]: 'Soft Credit Pull',
    [OnlineStep.paymentBuilder]: 'Payment Builder',
    [OnlineStep.upgradePackages]: 'Protection Plan',
    [OnlineStep.creditApplication]: 'Credit Application',
    [OnlineStep.schedulePickup]: 'Schedule Pickup/Delivery',
    [OnlineStep.testDrive]: 'Test Drive',
    [OnlineStep.deposit]: 'Deposit',
    [OnlineStep.vehicleSelection]: 'Vehicle Selection',
    [OnlineStep.customerInfo]: 'Customer Info',
    [OnlineStep.accessories]: 'Accessories',
    [OnlineStep.insurance]: 'Insurance',
    [OnlineStep.documentUpload]: 'Document Upload',
    [OnlineStep.signDocuments]: 'Sign Documents',
};
var WebPage;
(function (WebPage) {
    WebPage["browse"] = "browse";
    WebPage["summary"] = "summary";
    WebPage["examples"] = "examples";
    WebPage["settings"] = "settings";
    WebPage["lending"] = "lending";
    WebPage["offers"] = "offers";
})(WebPage || (exports.WebPage = WebPage = {}));
var WebStep;
(function (WebStep) {
    WebStep["payments"] = "payments";
    WebStep["creditApplication"] = "application";
    WebStep["tradeIn"] = "trade";
    WebStep["appointments"] = "appointments";
    WebStep["accessories"] = "accessories";
    WebStep["protectionPlans"] = "protection";
    WebStep["paymentBuilder"] = "paymentBuilder";
    WebStep["documentUpload"] = "documentUpload";
    WebStep["vehicleSelection"] = "vehicleSelection";
    WebStep["dealStart"] = "dealStart";
})(WebStep || (exports.WebStep = WebStep = {}));
exports.WebPagePath = {
    [WebPage.browse]: 'browse',
    [WebPage.summary]: 'summary',
    [WebPage.examples]: 'examples',
    [WebPage.settings]: 'settings',
    [WebPage.lending]: 'lending',
    [WebPage.offers]: 'offers',
};
exports.WebStepPath = {
    [WebStep.payments]: 'payments',
    [WebStep.creditApplication]: 'application',
    [WebStep.tradeIn]: 'trade',
    [WebStep.appointments]: 'appointments',
    [WebStep.accessories]: 'accessories',
    [WebStep.protectionPlans]: 'protection',
    [WebStep.paymentBuilder]: 'payment-builder',
    [WebStep.documentUpload]: 'document-upload',
    [WebStep.vehicleSelection]: 'vehicle-selection',
    [WebStep.dealStart]: 'deal-start',
};
exports.WebStepNames = {
    [WebStep.dealStart]: 'Deal Start',
    [WebStep.tradeIn]: 'Trade-in',
    [WebStep.paymentBuilder]: 'Payment Builder',
    [WebStep.creditApplication]: 'Credit Application',
    [WebStep.vehicleSelection]: 'Vehicle Selection',
    [WebStep.accessories]: 'Accessories',
    [WebStep.documentUpload]: 'Document Upload',
    [WebStep.payments]: 'Payments',
    [WebStep.appointments]: 'Appointments',
    [WebStep.protectionPlans]: 'Protection Plans',
};
var StoreStep;
(function (StoreStep) {
    StoreStep["driverLicense"] = "driverLicense";
    StoreStep["documentScan"] = "documentScan";
    StoreStep["vehicleSelection"] = "vehicleSelection";
    StoreStep["testDrive"] = "testDrive";
    StoreStep["tradeIn"] = "tradeIn";
    StoreStep["customerInfo"] = "customerInfo";
    StoreStep["creditApplication"] = "creditApplication";
    StoreStep["printed"] = "printed";
    StoreStep["carPaymentBuilder"] = "carPaymentBuilder";
    StoreStep["protectionPlans"] = "protectionPlans";
    StoreStep["pricingReview"] = "pricingReview";
    StoreStep["automaticTestDrive"] = "automaticTestDrive";
    StoreStep["accessories"] = "accessories";
    StoreStep["insurance"] = "insurance";
    StoreStep["financeAndInsuranceProductsViewed"] = "financeAndInsuranceProductsViewed";
    StoreStep["tradeStarted"] = "tradeStarted";
    StoreStep["incentivesViewed"] = "incentivesViewed";
    StoreStep["incentivesSelected"] = "incentivesSelected";
    StoreStep["paymentAdjusted"] = "paymentAdjusted";
    StoreStep["leaseAdjusted"] = "leaseAdjusted";
    StoreStep["financeAdjusted"] = "financeAdjusted";
    StoreStep["cashAdjusted"] = "cashAdjusted";
    StoreStep["downPaymentAdjusted"] = "downPaymentAdjusted";
    StoreStep["termAdjusted"] = "termAdjusted";
    StoreStep["financeRateAdjusted"] = "financeRateAdjusted";
    StoreStep["creditApplicationsStarted"] = "creditApplicationsStarted";
    StoreStep["sendDealToCustomer"] = "sendDealToCustomer";
    StoreStep["appointmentViewed"] = "appointmentViewed";
    StoreStep["appointmentRequested"] = "appointmentRequested";
})(StoreStep || (exports.StoreStep = StoreStep = {}));
exports.StoreMinutes = {
    [StoreStep.customerInfo]: 5,
    [StoreStep.vehicleSelection]: 15,
    [StoreStep.driverLicense]: 5,
    [StoreStep.documentScan]: 5,
    [StoreStep.creditApplication]: 10,
    [StoreStep.carPaymentBuilder]: 15,
    [StoreStep.creditApplication]: 15,
    [StoreStep.printed]: 10,
};
exports.OnlineMinutes = {
    [OnlineStep.vehicleSelection]: 30,
    [OnlineStep.tradeIn]: 30,
    [OnlineStep.paymentBuilder]: 15,
    [OnlineStep.creditApplication]: 60,
    [OnlineStep.upgradePackages]: 30,
};
var ActionType;
(function (ActionType) {
    ActionType["start"] = "start";
    ActionType["browse"] = "browse";
    ActionType["tradeIn"] = "tradeIn";
    ActionType["paymentOptions"] = "paymentBuilder";
    ActionType["preApproved"] = "creditApplication";
    ActionType["testDrive"] = "testDrive";
})(ActionType || (exports.ActionType = ActionType = {}));
var CLIENT_TYPE;
(function (CLIENT_TYPE) {
    CLIENT_TYPE["ONLINE"] = "online";
    CLIENT_TYPE["IN_STORE"] = "instore";
})(CLIENT_TYPE || (exports.CLIENT_TYPE = CLIENT_TYPE = {}));
var ONLINE_CLIENT_TYPE;
(function (ONLINE_CLIENT_TYPE) {
    ONLINE_CLIENT_TYPE["ONLINE"] = "online";
    ONLINE_CLIENT_TYPE["WEB"] = "web";
})(ONLINE_CLIENT_TYPE || (exports.ONLINE_CLIENT_TYPE = ONLINE_CLIENT_TYPE = {}));
exports.CLIENT_TYPE_HEADER = 'X-ClientType';
var Language;
(function (Language) {
    Language["EN_US"] = "en-US";
    Language["EN_CA"] = "en-CA";
    Language["ES_MX"] = "es-MX";
})(Language || (exports.Language = Language = {}));
var DateFormat;
(function (DateFormat) {
    DateFormat["MM_DD_YYYY"] = "MM/DD/YYYY";
    DateFormat["DD_MM_YYYY"] = "DD/MM/YYYY";
    DateFormat["YYYY_MM_DD"] = "YYYY/MM/DD";
})(DateFormat || (exports.DateFormat = DateFormat = {}));
var FuelEfficiencyUnit;
(function (FuelEfficiencyUnit) {
    FuelEfficiencyUnit["MPG"] = "mpg";
    FuelEfficiencyUnit["L_100KM"] = "l/100km";
})(FuelEfficiencyUnit || (exports.FuelEfficiencyUnit = FuelEfficiencyUnit = {}));
var HOUR_FORMATS;
(function (HOUR_FORMATS) {
    HOUR_FORMATS["HF_24"] = "24hr";
    HOUR_FORMATS["HF_12"] = "12hr";
})(HOUR_FORMATS || (exports.HOUR_FORMATS = HOUR_FORMATS = {}));
var CurrencyType;
(function (CurrencyType) {
    CurrencyType["USD"] = "USD";
    CurrencyType["CAD"] = "CAD";
})(CurrencyType || (exports.CurrencyType = CurrencyType = {}));
var FeeCategory;
(function (FeeCategory) {
    FeeCategory["TAXABLE"] = "taxable";
    FeeCategory["NON_TAXABLE"] = "nontaxable";
    FeeCategory["CAPITALIZED_COST"] = "capitalizedCost";
    FeeCategory["CAPITALIZED_COST_TAXABLE"] = "capitalizedCostTaxable";
})(FeeCategory || (exports.FeeCategory = FeeCategory = {}));
exports.FixedValueFee = 'fixedValueFee';
var SpecialFees;
(function (SpecialFees) {
    SpecialFees["FLORIDA_DOC_STAMP"] = "flDocStampFee";
    SpecialFees["CALIFORNIA_LICENSE"] = "caLicenseFee";
    SpecialFees["OREGON_PRIVILEGE_TAX"] = "orPrivilegeTax";
    SpecialFees["OREGON_CORPORATE_ACTIVITY_TAX"] = "orCorporateActivityTax";
    SpecialFees["TEXAS_VEHICLE_INVENTORY_TAX"] = "txVehicleInventoryTax";
    SpecialFees["TENNESSEE_BUSINESS_TAX"] = "tnBusinessTax";
})(SpecialFees || (exports.SpecialFees = SpecialFees = {}));
var PriceRuleOffsetType;
(function (PriceRuleOffsetType) {
    PriceRuleOffsetType["ADD"] = "add";
    PriceRuleOffsetType["SUBTRACT"] = "subtract";
    PriceRuleOffsetType["ADD_PERCENT"] = "add_percent";
    PriceRuleOffsetType["SUBTRACT_PERCENT"] = "subtract_percent";
})(PriceRuleOffsetType || (exports.PriceRuleOffsetType = PriceRuleOffsetType = {}));
var PriceRuleSource;
(function (PriceRuleSource) {
    PriceRuleSource["MSRP"] = "msrp";
    PriceRuleSource["INVOICE"] = "invoice";
    PriceRuleSource["FEED_PRICE"] = "feedPrice";
})(PriceRuleSource || (exports.PriceRuleSource = PriceRuleSource = {}));
var DealerCashRuleType;
(function (DealerCashRuleType) {
    DealerCashRuleType["PRICE_OFFSET_FIXED_MAX"] = "priceOffsetFixedMax";
    DealerCashRuleType["PRICE_OFFSET_PERCENT"] = "priceOffsetPercent";
})(DealerCashRuleType || (exports.DealerCashRuleType = DealerCashRuleType = {}));
var IncentivesProvider;
(function (IncentivesProvider) {
    IncentivesProvider["CHROMEDATA"] = "chromedata";
    IncentivesProvider["AIS"] = "ais";
})(IncentivesProvider || (exports.IncentivesProvider = IncentivesProvider = {}));
var CarUpgradeType;
(function (CarUpgradeType) {
    // manually configured upgrades from dealer.addOns
    CarUpgradeType["DEALER_ADDON"] = "dealer_addon";
    // upgrades from shift
    CarUpgradeType["SHIFT_ACCESSORY"] = "shift_accessory";
})(CarUpgradeType || (exports.CarUpgradeType = CarUpgradeType = {}));
/**
 *  Virtual Showroom chat author types
 */
var ChatAuthorType;
(function (ChatAuthorType) {
    // papyrus user
    ChatAuthorType["SALESPERSON"] = "salesperson";
    // online user
    ChatAuthorType["CUSTOMER"] = "customer";
})(ChatAuthorType || (exports.ChatAuthorType = ChatAuthorType = {}));
/**
 * Virtual Showroom chat message types
 */
var ChatMessageType;
(function (ChatMessageType) {
    // a text message
    ChatMessageType["MESSAGE"] = "message";
    // a message for when the customer changes the online page they're viewing
    ChatMessageType["ONLINE_PAGE_UPDATE"] = "online-page-update";
    // a request/accept/reject, by either the customer or salesperson, to start a video chat
    ChatMessageType["VIDEO_REQUEST"] = "video-request";
    ChatMessageType["VIDEO_ACCEPT"] = "video-accept";
    ChatMessageType["VIDEO_REJECT"] = "video-reject";
    // a notification that either the customer or salesperson disconnected from the video chat
    ChatMessageType["VIDEO_DISCONNECT"] = "video-disconnect";
    // a message from the salesperson indicating payments were updated
    ChatMessageType["PAYMENTS_UPDATE"] = "payments-update";
    // a message from the salesperson for requesting a deposit
    ChatMessageType["DEPOSIT_REQUEST"] = "deposit-request";
    // a request from a salesperson to switch a customer's vehicle
    ChatMessageType["SWITCH_VEHICLE_REQUEST"] = "switch-vehicle-request";
    // message indicating the vehicle was accepted
    ChatMessageType["SWITCH_VEHICLE_ACCEPT"] = "switch-vehicle-accept";
    // message indicating the vehicle was rejected
    ChatMessageType["SWITCH_VEHICLE_REJECT"] = "switch-vehicle-reject";
    // message indicating the chat is attempting to reconnect with another salesperson
    ChatMessageType["CHAT_RECONNECT"] = "chat-reconnect";
})(ChatMessageType || (exports.ChatMessageType = ChatMessageType = {}));
/**
 * Virtual Showroom chat message video reject types
 */
var ChatMessageVideoRejectType;
(function (ChatMessageVideoRejectType) {
    // online browser doesn't support video chat
    ChatMessageVideoRejectType["UNSUPPORTED"] = "unsupported";
    // user rejected the request
    ChatMessageVideoRejectType["USER"] = "user";
})(ChatMessageVideoRejectType || (exports.ChatMessageVideoRejectType = ChatMessageVideoRejectType = {}));
var ChatStatus;
(function (ChatStatus) {
    ChatStatus["REQUESTED"] = "requested";
    ChatStatus["ACCEPTED"] = "accepted";
    ChatStatus["REQUEST_TIMEOUT"] = "request-timeout";
})(ChatStatus || (exports.ChatStatus = ChatStatus = {}));
var ChatEventName;
(function (ChatEventName) {
    // Video chat is started
    ChatEventName["VIDEO_CHAT"] = "video-chat";
    // Deposit was requested
    ChatEventName["DEPOSIT_REQUEST"] = "deposit-request";
    // Chat request was received by salesperson
    ChatEventName["CHAT_REQUEST"] = "chat-request";
    // Vehicle suggestion was sent
    ChatEventName["VEHICLE_SUGGESTION"] = "vehicle-suggestion";
    // Salesperson marked himself as available online
    ChatEventName["ONLINE_AVAILABILITY"] = "online-availability";
})(ChatEventName || (exports.ChatEventName = ChatEventName = {}));
/**
 * Used to distinguish PEN Provider vs User (custom) created products
 */
exports.PenProductSource = {
    PROVIDER: 'provider',
    USER: 'user',
};
var Makes;
(function (Makes) {
    Makes["Acura"] = "acura";
    Makes["Alfa-Romeo"] = "alfa-romeo";
    Makes["Aston-Martin"] = "aston-martin";
    Makes["Audi"] = "audi";
    Makes["BMW"] = "bmw";
    Makes["Bentley"] = "bentley";
    Makes["Buick"] = "buick";
    Makes["Cadillac"] = "cadillac";
    Makes["Chevrolet"] = "chevrolet";
    Makes["Chrysler"] = "chrysler";
    Makes["Corvette"] = "corvette";
    Makes["Dodge"] = "dodge";
    Makes["Fiat"] = "fiat";
    Makes["Ferrari"] = "ferrari";
    Makes["Ford"] = "ford";
    Makes["GMC"] = "gmc";
    Makes["Genesis"] = "genesis";
    Makes["Honda"] = "honda";
    Makes["Hummer"] = "hummer";
    Makes["Hyundai"] = "hyundai";
    Makes["INFINITI"] = "infiniti";
    Makes["Jaguar"] = "jaguar";
    Makes["Jeep"] = "jeep";
    Makes["Kia"] = "kia";
    Makes["Lamborghini"] = "lamborghini";
    Makes["Land-Rover"] = "land-rover";
    Makes["Lexus"] = "lexus";
    Makes["Lincoln"] = "lincoln";
    Makes["MINI"] = "mini";
    Makes["Maserati"] = "maserati";
    Makes["Mazda"] = "mazda";
    Makes["Mercedes-Benz"] = "mercedes-benz";
    Makes["Mercury"] = "mercury";
    Makes["Mitsubishi"] = "mitsubishi";
    Makes["Mustang"] = "mustang";
    Makes["Nissan"] = "nissan";
    Makes["Pontiac"] = "pontiac";
    Makes["Porsche"] = "porsche";
    Makes["Ram"] = "ram";
    Makes["Saturn"] = "saturn";
    Makes["Scion"] = "scion";
    Makes["Smart"] = "smart";
    Makes["Subaru"] = "subaru";
    Makes["Toyota"] = "toyota";
    Makes["Volkswagen"] = "volkswagen";
    Makes["Volvo"] = "volvo";
})(Makes || (exports.Makes = Makes = {}));
var ImportStatus;
(function (ImportStatus) {
    ImportStatus["IMPORT_STARTED"] = "import-started";
    ImportStatus["IMPORT_RUNNING"] = "import-running";
    ImportStatus["IMPORT_FINISHED"] = "import-finished";
    ImportStatus["IMPORT_FEED_FILE_SKIPPED"] = "import-feed-file-skipped";
    ImportStatus["IMPORT_TIMEOUT"] = "import-timeout";
    ImportStatus["IMPORT_ERROR"] = "import-error";
})(ImportStatus || (exports.ImportStatus = ImportStatus = {}));
var InsuranceProvider;
(function (InsuranceProvider) {
    InsuranceProvider["ROOT"] = "root";
    InsuranceProvider["COVER"] = "cover";
    InsuranceProvider["JERRY"] = "jerry";
})(InsuranceProvider || (exports.InsuranceProvider = InsuranceProvider = {}));
var InsuranceEventType;
(function (InsuranceEventType) {
    InsuranceEventType["TEXT_SENT"] = "TEXT_SENT";
    InsuranceEventType["TEXT_CLICK"] = "TEXT_CLICK";
    InsuranceEventType["TEXT_CONVERSION"] = "TEXT_CONVERSION";
    InsuranceEventType["INSURANCE_APPLICATION"] = "INSURANCE_APPLICATION";
})(InsuranceEventType || (exports.InsuranceEventType = InsuranceEventType = {}));
var InsuranceRequestType;
(function (InsuranceRequestType) {
    InsuranceRequestType["TEXT"] = "text";
})(InsuranceRequestType || (exports.InsuranceRequestType = InsuranceRequestType = {}));
var FinanceProvider;
(function (FinanceProvider) {
    FinanceProvider["ROUTEONE"] = "routeone";
    FinanceProvider["WESTLAKE"] = "westlake";
    FinanceProvider["DEALERTRACK"] = "dealertrack";
    FinanceProvider["UPSTART"] = "upstart";
})(FinanceProvider || (exports.FinanceProvider = FinanceProvider = {}));
var FinanceApplicationStatus;
(function (FinanceApplicationStatus) {
    FinanceApplicationStatus["ACTIVE"] = "active";
    FinanceApplicationStatus["INACTIVE"] = "inactive";
    FinanceApplicationStatus["FAILED"] = "failed";
})(FinanceApplicationStatus || (exports.FinanceApplicationStatus = FinanceApplicationStatus = {}));
var FinanceResponseStatus;
(function (FinanceResponseStatus) {
    FinanceResponseStatus["APPROVED"] = "approved";
    FinanceResponseStatus["DENIED"] = "denied";
    FinanceResponseStatus["CONDITION"] = "condition";
    FinanceResponseStatus["PRELIMINARY"] = "preliminary";
    FinanceResponseStatus["WITHDRAWN"] = "withdrawn";
    FinanceResponseStatus["BOOKED"] = "booked";
    FinanceResponseStatus["ERROR"] = "error";
    FinanceResponseStatus["NONE"] = "none";
})(FinanceResponseStatus || (exports.FinanceResponseStatus = FinanceResponseStatus = {}));
var Signer;
(function (Signer) {
    Signer["APPLICANT"] = "applicant";
    Signer["COAPPLICANT"] = "coapplicant";
    Signer["MANAGER"] = "manager";
})(Signer || (exports.Signer = Signer = {}));
var FormPackType;
(function (FormPackType) {
    FormPackType["ONLINE"] = "Online";
    FormPackType["INSTORE"] = "In-store";
})(FormPackType || (exports.FormPackType = FormPackType = {}));
var LendingFlowType;
(function (LendingFlowType) {
    LendingFlowType["AUTOMATIC"] = "automatic";
    LendingFlowType["MANAGER"] = "manager";
})(LendingFlowType || (exports.LendingFlowType = LendingFlowType = {}));
var AppointmentType;
(function (AppointmentType) {
    AppointmentType["TEST_DRIVE"] = "testDrive";
    AppointmentType["PICKUP_OR_DELIVERY"] = "pickupOrDelivery";
})(AppointmentType || (exports.AppointmentType = AppointmentType = {}));
exports.default = Constants;
var PixallAnalyticsEventTypes;
(function (PixallAnalyticsEventTypes) {
    PixallAnalyticsEventTypes["DR_TOOL_OPEN"] = "DR_TOOL_OPENED";
    PixallAnalyticsEventTypes["DR_CHAT_START"] = "DR_TOOL_OPENED_CHAT_INITIATED";
    PixallAnalyticsEventTypes["DR_UNLOCK_FORM_SUBMITTED"] = "FORM_UNLOCK_SUBMISSION";
    PixallAnalyticsEventTypes["DR_INITIAL_INTERACTION"] = "DR_INITIAL_INTERACTION";
    PixallAnalyticsEventTypes["DR_PAYMENT_CALCULATOR_ENGAGEMENT"] = "PENCILING_PAYMENT_CALCULATOR";
    PixallAnalyticsEventTypes["DR_TRADEIN_START"] = "DR_TRADE_START";
    PixallAnalyticsEventTypes["DR_TRADEIN_SUBMISSION"] = "DR_TRADEIN_SUBMISSION";
    PixallAnalyticsEventTypes["DR_CREDIT_APP_START"] = "CREDIT_APP_STARTED";
    PixallAnalyticsEventTypes["DR_CREDIT_APP_SUBMIT"] = "DR_SUBMISSION";
    PixallAnalyticsEventTypes["DR_DEPOSIT_SUBMIT"] = "DEPOSIT_SUBMITTED";
    PixallAnalyticsEventTypes["DR_DEAL_SUBMIT"] = "DEAL_SUBMITTED";
    PixallAnalyticsEventTypes["DR_DIGITAL_CONTRACT_START"] = "DR_DIGITAL_CONTRACT_START";
    PixallAnalyticsEventTypes["DR_DIGITAL_CONTRACT_SUBMIT"] = "DIGITAL_CONTRACT_SUBMITTED";
    PixallAnalyticsEventTypes["DR_DELIVERY_REQUEST"] = "HOME_DELIVERY_REQUEST";
})(PixallAnalyticsEventTypes || (exports.PixallAnalyticsEventTypes = PixallAnalyticsEventTypes = {}));
var ShiftAnalyticsEventTypes;
(function (ShiftAnalyticsEventTypes) {
    ShiftAnalyticsEventTypes["drInitialClick"] = "drInitialClick";
    ShiftAnalyticsEventTypes["drPaymentCalcFinish"] = "drPaymentCalcFinish";
    ShiftAnalyticsEventTypes["drLeadFormStart"] = "drLeadFormStart";
    ShiftAnalyticsEventTypes["drLeadFormFinish"] = "drLeadFormFinish";
    ShiftAnalyticsEventTypes["drFiFinish"] = "drFiFinish";
    ShiftAnalyticsEventTypes["drDropSave"] = "drDropSave";
    // v2.0 has those new events below
    ShiftAnalyticsEventTypes["drImpression"] = "drImpression";
    ShiftAnalyticsEventTypes["drTradeInShown"] = "drTradeInShown";
    ShiftAnalyticsEventTypes["drTradeInStart"] = "drTradeInStart";
    ShiftAnalyticsEventTypes["drTradeInFinish"] = "drTradeInFinish";
    ShiftAnalyticsEventTypes["drPaymentCalcShown"] = "drPaymentCalcShown";
    ShiftAnalyticsEventTypes["drPaymentCalcInteraction"] = "drPaymentCalcInteraction";
    ShiftAnalyticsEventTypes["drLeadFormShown"] = "drLeadFormShown";
    ShiftAnalyticsEventTypes["drApptSchedShown"] = "drApptSchedShown";
    ShiftAnalyticsEventTypes["drApptSchedStart"] = "drApptSchedStart";
    ShiftAnalyticsEventTypes["drApptSchedFinish"] = "drApptSchedFinish";
    ShiftAnalyticsEventTypes["drPreQShown"] = "drPreQShown";
    ShiftAnalyticsEventTypes["drPreQStart"] = "drPreQStart";
    ShiftAnalyticsEventTypes["drPreQFinish"] = "drPreQFinish";
    ShiftAnalyticsEventTypes["drCreditAppShown"] = "drCreditAppShown";
    ShiftAnalyticsEventTypes["drCreditAppStart"] = "drCreditAppStart";
    ShiftAnalyticsEventTypes["drCreditAppFinish"] = "drCreditAppFinish";
    ShiftAnalyticsEventTypes["drFiShown"] = "drFiShown";
    ShiftAnalyticsEventTypes["drAccessoriesShown"] = "drAccessoriesShown";
    ShiftAnalyticsEventTypes["drAddToCart"] = "drAddToCart";
    ShiftAnalyticsEventTypes["drAccessoriesFinish"] = "drAccessoriesFinish";
    ShiftAnalyticsEventTypes["drContractShown"] = "drContractShown";
    ShiftAnalyticsEventTypes["drContractStart"] = "drContractStart";
    ShiftAnalyticsEventTypes["drContractFinish"] = "drContractFinish";
    ShiftAnalyticsEventTypes["drOfferAdded"] = "drOfferAdded";
    // byo events
    ShiftAnalyticsEventTypes["byoBuildStart"] = "byoBuildStart";
    ShiftAnalyticsEventTypes["byoModelShown"] = "byoModelShown";
    ShiftAnalyticsEventTypes["byoModelSelected"] = "byoModelSelected";
    ShiftAnalyticsEventTypes["byoModelTrimShown"] = "byoModelTrimShown";
    ShiftAnalyticsEventTypes["byoModelTrimSelected"] = "byoModelTrimSelected";
    ShiftAnalyticsEventTypes["byoInteraction"] = "byoInteraction";
    ShiftAnalyticsEventTypes["byoExteriorColorShown"] = "byoExteriorColorShown";
    ShiftAnalyticsEventTypes["byoExteriorColorSelected"] = "byoExteriorColorSelected";
    ShiftAnalyticsEventTypes["byoInteriorColorShown"] = "byoInteriorColorShown";
    ShiftAnalyticsEventTypes["byoInteriorColorSelected"] = "byoInteriorColorSelected";
    ShiftAnalyticsEventTypes["byoPackagesShown"] = "byoPackagesShown";
    ShiftAnalyticsEventTypes["byoPackagesSelected"] = "byoPackagesSelected";
    ShiftAnalyticsEventTypes["byoLeadFormShown"] = "byoLeadFormShown";
    ShiftAnalyticsEventTypes["byoLeadFormStart"] = "byoLeadFormStart";
    ShiftAnalyticsEventTypes["byoLeadFormFinish"] = "byoLeadFormFinish";
    ShiftAnalyticsEventTypes["byoDropSave"] = "byoDropSave";
    ShiftAnalyticsEventTypes["byoSummaryShown"] = "byoSummaryShown";
    ShiftAnalyticsEventTypes["byoPurchaseStart"] = "byoPurchaseStart";
    ShiftAnalyticsEventTypes["byoAccessoriesShown"] = "byoAccessoriesShown";
    ShiftAnalyticsEventTypes["byoAccessoriesSelected"] = "byoAccessoriesSelected";
    ShiftAnalyticsEventTypes["byoTransmissionShown"] = "byoTransmissionShown";
    ShiftAnalyticsEventTypes["byoTransmissionSelected"] = "byoTransmissionSelected";
})(ShiftAnalyticsEventTypes || (exports.ShiftAnalyticsEventTypes = ShiftAnalyticsEventTypes = {}));
// When tradeIn info is actually pulled from those systems, they come with
// extra info that we don't use internally. Depending on the source chosen here,
// the tradeInMeta takes a different shape
var TradeInDataSource;
(function (TradeInDataSource) {
    TradeInDataSource["VINSOLUTIONS"] = "vinsolutions";
    TradeInDataSource["ELEAD"] = "elead";
})(TradeInDataSource || (exports.TradeInDataSource = TradeInDataSource = {}));
exports.COMMUNITY_PROPERTY_STATES = [
    'AZ',
    'CA',
    'ID',
    'LA',
    'NV',
    'NM',
    'TX',
    'WA',
    'WI',
];
var STICKER_FORMAT;
(function (STICKER_FORMAT) {
    STICKER_FORMAT["JPG"] = "jpg";
    STICKER_FORMAT["PDF"] = "pdf";
})(STICKER_FORMAT || (exports.STICKER_FORMAT = STICKER_FORMAT = {}));
// Used for Upstart applications
var IncomeType;
(function (IncomeType) {
    IncomeType["EMPLOYED_SALARY"] = "Employed - Salary";
    IncomeType["EMPLOYED_HOURLY"] = "Employed - Hourly";
    IncomeType["EMPLOYED_INDEPENDENT_CONTRACTOR"] = "Employed - Independent Contractor";
    IncomeType["SELF_EMPLOYED_SOLE_PROPRIETOR"] = "Self Employed - Sole Proprietor";
    IncomeType["SELF_EMPLOYED_PARTNERSHIP_LLC"] = "Self Employed - Partnership/LLC";
    IncomeType["OTHER"] = "Other";
})(IncomeType || (exports.IncomeType = IncomeType = {}));
// Used for "Employed - Hourly" Income Type for Upstart applications
var IncomeSubType;
(function (IncomeSubType) {
    IncomeSubType["FULL_TIME"] = "Full Time";
    IncomeSubType["PART_TIME"] = "Part Time";
    IncomeSubType["CONTRACT"] = "Contract";
})(IncomeSubType || (exports.IncomeSubType = IncomeSubType = {}));
// Used for "Employed - Hourly" Income Type for Upstart applications
var PaycheckFrequency;
(function (PaycheckFrequency) {
    PaycheckFrequency["WEEKLY"] = "Weekly";
    PaycheckFrequency["BIWEEKLY"] = "Biweekly";
    PaycheckFrequency["SEMIMONTHLY"] = "Semimonthly";
    PaycheckFrequency["MONTHLY"] = "Monthly";
})(PaycheckFrequency || (exports.PaycheckFrequency = PaycheckFrequency = {}));
var OtherIncomeType;
(function (OtherIncomeType) {
    OtherIncomeType["ALIMONY"] = "Alimony";
    OtherIncomeType["CHILD_SUPPORT"] = "Child Support";
    OtherIncomeType["RETIREMENT_AND_PENSION_INCOME"] = "Retirement and pension income";
    OtherIncomeType["RENTAL_INCOME"] = "Rental Income";
    OtherIncomeType["DISABILITY_BENEFITS"] = "Disability benefits";
    OtherIncomeType["STIPEND_OR_SCHOLARSHIP"] = "Stipend or Scholarship";
    OtherIncomeType["OTHER"] = "Other";
})(OtherIncomeType || (exports.OtherIncomeType = OtherIncomeType = {}));
var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["email"] = "email";
})(NotificationChannel || (exports.NotificationChannel = NotificationChannel = {}));
var BlackbookValuationType;
(function (BlackbookValuationType) {
    BlackbookValuationType["VIN"] = "VIN";
    BlackbookValuationType["YMMSS"] = "YMMSS";
})(BlackbookValuationType || (exports.BlackbookValuationType = BlackbookValuationType = {}));
var DealerType;
(function (DealerType) {
    DealerType["Default"] = "Default";
    DealerType["BYO_ENABLED"] = "BYOEnabled";
    DealerType["BYO_ONLY"] = "BYOOnly";
})(DealerType || (exports.DealerType = DealerType = {}));
exports.NO_SELECTED_MAKES = 'NO_SELECTED_MAKES';
exports.FAUX_TRADE_IN_ID = 'faux-trade-in';
var LenderNames;
(function (LenderNames) {
    LenderNames["ALLY"] = "ally";
    LenderNames["US_BANK"] = "us_bank";
    LenderNames["CHASE"] = "chase";
    LenderNames["BANK_OF_AMERICA"] = "bank_of_america";
    LenderNames["SANTANDER"] = "santander";
})(LenderNames || (exports.LenderNames = LenderNames = {}));
exports.LENDERS = [
    'Ally Financial',
    'US Bank',
    'Chase',
    'Bank of America',
    'Santander Consumer USA, Inc.',
];
exports.defaultLendersIDs = [1, 5, 17, 37, 457];
exports.LENDER_KEY_TO_LABEL = {
    [LenderNames.ALLY]: 'Ally Financial',
    [LenderNames.US_BANK]: 'US Bank',
    [LenderNames.CHASE]: 'Chase',
    [LenderNames.BANK_OF_AMERICA]: 'Bank of America',
    [LenderNames.SANTANDER]: 'Santander Consumer USA, Inc.',
};
exports.LENDER_KEY_TO_ID = {
    [LenderNames.ALLY]: 1,
    [LenderNames.US_BANK]: 5,
    [LenderNames.CHASE]: 17,
    [LenderNames.BANK_OF_AMERICA]: 37,
    [LenderNames.SANTANDER]: 457,
};
exports.ORDERED_LENDERS = [
    LenderNames.ALLY,
    LenderNames.US_BANK,
    LenderNames.CHASE,
    LenderNames.BANK_OF_AMERICA,
    LenderNames.SANTANDER,
];
var ProtectionPlansSelectionType;
(function (ProtectionPlansSelectionType) {
    ProtectionPlansSelectionType["Mandatory"] = "mandatory";
    ProtectionPlansSelectionType["Default"] = "default";
    ProtectionPlansSelectionType["None"] = "none";
})(ProtectionPlansSelectionType || (exports.ProtectionPlansSelectionType = ProtectionPlansSelectionType = {}));
var PreferredContactMethod;
(function (PreferredContactMethod) {
    PreferredContactMethod["EMAIL"] = "email";
    PreferredContactMethod["PHONE"] = "phone";
    PreferredContactMethod["TEXT"] = "text";
})(PreferredContactMethod || (exports.PreferredContactMethod = PreferredContactMethod = {}));
var ThirdPartyAccessoryProvider;
(function (ThirdPartyAccessoryProvider) {
    ThirdPartyAccessoryProvider["ShiftDigitalFTP"] = "shiftDigitalFTP";
    ThirdPartyAccessoryProvider["Insignia"] = "insignia";
})(ThirdPartyAccessoryProvider || (exports.ThirdPartyAccessoryProvider = ThirdPartyAccessoryProvider = {}));
var DisplayFormat;
(function (DisplayFormat) {
    DisplayFormat["MONEY"] = "money";
    DisplayFormat["PERCENT"] = "percent";
})(DisplayFormat || (exports.DisplayFormat = DisplayFormat = {}));
exports.UPSTART_MIN_FINANCE_AMOUNT = 9000;
exports.UPSTART_MAX_FINANCE_AMOUNT = 100000;
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ../../../src/legos/constants/index.ts